// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6366":"c583d334","6746":"5b098a03"}[chunkId] + ".chunk.css";
};